
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book/search",
      function () {
        return require("private-next-pages/book/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book/search"])
      });
    }
  